export const isValidUrl = (url: string): boolean => {
  try {
    const parsedUrl = new URL(url);
    //Only https urls are allowed
    return parsedUrl.protocol === "https:";
  } catch (e) {
    return false;
  }
};
